<template>
  <div>
    <v-layout wrap>
      <v-flex >
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            key-property="classId"
            search-url="/kidClassBabiPro/getAlllistClass"
            create-url="/kidClassBabiPro/save"
            delete-url="/kidClassBabiPro/delete"
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            custom-edit-item
            @editItem="openCreateDialog"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete="true"
            :acceptView="true"
            @viewItem="viewItem"
        >
        </c-search-form>
        <!--            search-url="/kidClass/search/?sortField=status,classId&"-->
        <material-type-group-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
            :hiddenFields="hiddenFields"
        />
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../components/form/ManageForm";
import {areaContants, cateContants} from "@/constants";
import axios from "axios";
import MaterialTypeGroupCreate from "@/views/babiPro/ClassBabiProCreate";
import {classIsActive, levelBabiPro} from "@/constants/cateContants";

export default {
  name: "warehouse",
  components: {MaterialTypeGroupCreate, CSearchForm},
  data: () => {
    return {
      formName: "Thông tin lớp học Babi Pro",
      formCreateName: "Thêm mới lớp học Babi Pro",
      category: null,
      lastSearchValues: {},
      visibleCreateDialog: false,
      timeReload: 0,
      hiddenFields: {
        typeId: "0",
      },
      fields: [
        {
          value: "index",
          text: "lang.common.index",
          width: "3%",
          sortable: false,
          headerStyle: "text-align:center"
        },
        {
          value: 'className',
          text: 'Tên lớp',
          sortable: false,
          search: true,
          width: "8%",
          headerStyle: "text-align:center"
        },
        {
          value: 'degree',
          text: 'Trình độ',
          sortable: false,
          search: true,
          width: "5%",
          headerStyle: "text-align:center"
        },
        {
          value: "level",
          text: "Level",
          search: true,
          headerStyle: "text-align:center",
          type: "select",
          name: "level",
          items: cateContants.levelBabiPro,
          itemText: "text",
          itemValue: "value",
          width: "5%"
        },
        {
          value: 'programTimeId',
          text: 'Khung thời gian',
          width: "7%",
          sortable: false,
          search: true,
          headerStyle: "text-align:center",
          type: "select",
          name: "programTimeId",
          items: [],
          itemText: "programTimeName",
          itemValue: "programTimeId"
        },
        {
          value: 'packageId',
          text: 'Gói học',
          width: "5%",
          sortable: false,
          search: true,
          headerStyle: "text-align:center",
          type: "select",
          name: "packageId",
          items: [],
          itemText: "packageName",
          itemValue: "packageId"
        },
        {
          value: 'startDate',
          text: 'Ngày bắt đầu',
          type: "date",
          sortable: true,
          search: true,
          width: "5%",
          dateFormat: 'dd/MM/yyyy',
          headerStyle: "text-align:center",
          fromDate: "fromDateStart",
          toDate: "toDateStart"
        },
        {
          value: 'endDate',
          text: 'Ngày kết thúc',
          type: "date",
          sortable: true,
          search: true,
          width: "5%",
          dateFormat: 'dd/MM/yyyy',
          headerStyle: "text-align:center",
          fromDate: "fromDateEnd",
          toDate: "toDateEnd"
        },
        {
          value: 'teachersId1',
          text: 'Giáo viên buổi 1',
          width: "5%",
          sortable: false,
          search: true,
          headerStyle: "text-align:center",
          type: "select",
          name: "teachersId1",
          items: [],
          itemText: "nameTeacher",
          itemValue: "id"
        },
        {
          value: 'teachersId2',
          text: 'Giáo viên buổi 2',
          width: "5%",
          sortable: false,
          search: true,
          headerStyle: "text-align:center",
          type: "select",
          name: "teachersId2",
          items: [],
          itemText: "nameTeacher",
          itemValue: "id"
        },
        {
          value: 'teachersId3',
          text: 'Giáo viên buổi 3',
          width: "5%",
          sortable: false,
          search: true,
          headerStyle: "text-align:center",
          type: "select",
          name: "teachersId3",
          items: [],
          itemText: "nameTeacher",
          itemValue: "id"
        },
        {
          value: 'teachersIdTa',
          text: 'Giáo viên TA',
          width: "5%",
          sortable: false,
          search: true,
          headerStyle: "text-align:center",
          type: "select",
          name: "teachersIdTa",
          items: [],
          itemText: "nameTeacher",
          itemValue: "id"
        },
        {
          value: "action",
          text: "lang.common.actions",
          sortable: false,
          compound: true,
          width: "15%",
          headerStyle: "text-align:center",
        },
      ],
    };
  },

  created() {
    axios.post(
        process.env.VUE_APP_API_URL + "/kidProgramTime/listAllName", {isActive: 1}
    )
        .then(
            (data) => {
              console.info(data)
              let itemFields = this.fields.filter(function (e) {
                return e.name == "programTimeId";
              });

              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
        );

    axios.post(
        process.env.VUE_APP_API_URL + "/kidPackage/listAllName", {isActive: 1}
    )
        .then(
            (data) => {
              console.info(data)
              let itemFields = this.fields.filter(function (e) {
                return e.name == "packageId";
              });

              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
        );
    axios.post(
        process.env.VUE_APP_API_URL + "/kidTeacher/listAllNameTypeVN", {isActive: 1}
    )
        .then(
            (data) => {
              let itemFields = this.fields.filter(function (e) {
                return e.name == "teachersId1";
              });

              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
        );
    axios.post(
        process.env.VUE_APP_API_URL + "/kidTeacher/listAllNameTypeVN", {isActive: 1}
    )
        .then(
            (data) => {
              let itemFields = this.fields.filter(function (e) {
                return e.name == "teachersIdTa";
              });

              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
        );
    axios.post(
        process.env.VUE_APP_API_URL + "/kidTeacher/listAllName", {isActive: 1}
    )
        .then(
            (data) => {
              let itemFields = this.fields.filter(function (e) {
                return e.name == "teachersId2";
              });

              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
        );

    axios.post(
        process.env.VUE_APP_API_URL + "/kidTeacher/listAllName", {isActive: 1}
    )
        .then(
            (data) => {
              let itemFields = this.fields.filter(function (e) {
                return e.name == "teachersId3";
              });

              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
        );
  },

  methods: {
    clearFromDate() {
      this.hiddenFields.fromDate = null;
    },
    clearToDate() {
      this.hiddenFields.toDate = null;
    },
    onChangeFromDate(date) {
      this.hiddenFields.fromDate = date;
    },
    onChangeToDate(date) {
      this.hiddenFields.toDate = date;
    },
    openCreateDialog: function (item = null) {
      if (item == null) {
        this.formCreateName = 'Thêm mới lớp học Babi Pro';
        this.getNextCode();
      } else {
        this.category = item;
        this.formCreateName = 'Cập nhật lớp học Babi Pro';
        this.visibleCreateDialog = true;
      }
    },
    closeCreateDialog: function () {
      this.category = null;
      this.visibleCreateDialog = false;
      this.timeReload = Math.floor(Math.random() * 100);
    },

    getNextCode: function () {
      axios.get(
          process.env.VUE_APP_API_URL +
          "/autoIncrease/getNextNumber?type=MATERIAL_TYPE_ALLY"
      )
          .then((data) => {
            this.category = Object.assign({}, this.category, {"categoryCode": "MATERIAL_TYPE_ALLY" + data, "status": 1})
            this.visibleCreateDialog = true;
          });
    },
    createParamLastSearch: function (values) {
      const obj1 = {
        searchImportRequest: JSON.stringify(values),
      };
      const obj2 = this.$route.query;
      return {...obj1, ...obj2};
    },
    viewItem: function (item) {
      this.$router.push({
        path: '/classPro/view/' + item.classIdPro, query: this.createParamLastSearch(this.lastSearchValues)
      });
    },
  },

  destroyed() {
  },
};
</script>
